import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11bbd99c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "login-image",
  src: "/assets/images/login_background.jpg"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Recupera password", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Inserisci il tuo codice fiscale", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Inserisci la nuova password e il codice di conferma ricevuto via email", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "12",
                    "offset-lg": "3",
                    "size-lg": "6",
                    "offset-xl": "4",
                    "size-xl": "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, { style: {"margin":"0","height":"100%"} }, {
                        default: _withCtx(() => [
                          _hoisted_1,
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              ($data.step === 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_3,
                                    _createVNode(_component_ion_list, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_input, {
                                              placeholder: "Codice fiscale",
                                              modelValue: $data.username,
                                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.username) = $event)),
                                              required: ""
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _hoisted_4,
                                        _createVNode(_component_ion_button, {
                                          shape: "round",
                                          expand: "block",
                                          size: "default",
                                          disabled: !$data.username || $data.submitting,
                                          onClick: $options.submit
                                        }, {
                                          default: _withCtx(() => [
                                            ($data.submitting)
                                              ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                                  key: 0,
                                                  name: "circular"
                                                }))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_5, "Invia"))
                                          ]),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true),
                              ($data.step === 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_6,
                                    _createVNode(_component_ion_list, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_input, {
                                              placeholder: "Nuova password",
                                              type: "password",
                                              modelValue: $data.password,
                                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.password) = $event)),
                                              required: ""
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_input, {
                                              placeholder: "Conferma nuova password",
                                              type: "password",
                                              modelValue: $data.passwordConfirm,
                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.passwordConfirm) = $event)),
                                              required: ""
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_input, {
                                              placeholder: "Codice di conferma",
                                              modelValue: $data.ccode,
                                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.ccode) = $event)),
                                              required: ""
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _hoisted_7,
                                        _createVNode(_component_ion_button, {
                                          shape: "round",
                                          expand: "block",
                                          size: "default",
                                          disabled: !$data.ccode || !$data.password || $data.submitting,
                                          onClick: $options.submitConfirmationCode
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Conferma "),
                                            ($data.submitting)
                                              ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                                  key: 0,
                                                  name: "circular"
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}